
export const formatCmxRomDescKey = (id: string) => `rom.${id}.description`;
export const formatCmxRomNameKey = (id: string) => `rom.${id}.name`;
export const formatCmxRomInstructionsKey = (id: string) => `rom.${id}.instructions`;

export const formatCmxArcadeNameKey = (id: string) => `arcade.${id}.name`;
export const formatCmxRoomNameKey = (id: string) => `room.${id}.name`;

export const formatCmxCabinetDescKey = (id: string) => `cabinet.${id}.description`;
export const formatCmxCabinetNameKey = (id: string) => `cabinet.${id}.name`;
export const formatCmxCabinetInstructionsKey = (id: string) => `cabinet.${id}.instructions`;
